import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
}: Theme) => ({
  paper: {
    '&&': {
      maxWidth: '95vw',
      width: '27.5rem',
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  paperWide: {
    '&&': {
      width: '31.25rem',
    },
  },
  content: {
    '&&': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  button: {
    marginLeft: '1rem',
    marginBottom: '2rem',
    [breakpoints.up('sm')]: {
      marginLeft: '3rem',
      marginBottom: '3rem',
    },
  },
}));
